import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class DataBox extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.any,
    style: PropTypes.any,
    contentHeight: PropTypes.any,
    className: PropTypes.string,
  };

  render() {
    const { title, children, style, contentHeight, className } = this.props;

    return (
      <div
        className={`flex h-full flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm ${className || ''}`}
        style={{ ...style, ...(contentHeight ? { minHeight: contentHeight } : {}) }}
      >
        <div className="border-b border-gray-100 bg-gray-50 px-4 py-3">
          <h2 className="text-sm font-semibold tracking-wide text-gray-800">{title}</h2>
        </div>
        <div className="flex-1 overflow-auto p-4">{children}</div>
      </div>
    );
  }
}
